import React from 'react';
import { People } from 'components/people/People';
import { PeopleItem } from 'components/people/PeopleItem';
import { RichText } from 'components/rich-text/RichText';

export const PeopleSlice = ({ title, tagline, text, items, isSlice }) => {
  if (items?.length === 0) {
    return null;
  }

  return (
    <People title={title} tagline={tagline} text={RichText.render(text)} isSlice={isSlice}>
      {items?.map((item, index) => (
        <PeopleItem
          key={index}
          image={item.image}
          name={item.name}
          position={item.position}
          bio={RichText.render(item.bio)}
          tel={item.phonenumber}
          email={item.email}
          link={item.link}
          altLink={item.altLink}
        />
      ))}
    </People>
  );
};

export default PeopleSlice;
